module.exports = __webpack_public_path__ + "static/media/handshake.8bbcb6a0.png";